import dayjs from 'dayjs';
import { createReducer } from 'typesafe-actions';
import filterDates from 'store/ducks/filter/filter-dates';
import { FilterState } from './types';
import { ReportType } from '../statements/types';
import { updateFilter } from './actions';

export const TOMORROW = dayjs().add(1, 'day').format('YYYY-MM-DD');
export const TODAY = dayjs().format('YYYY-MM-DD');

export const INITIAL_STATE: FilterState = {
  periodStart: filterDates.today.date,
  periodEnd: filterDates.today.date,
  reportType: ReportType.All,
  isFirstLoad: true,
};

export type RootFilterAction = ReturnType<typeof updateFilter>;

const filterReducer = createReducer<FilterState, RootFilterAction>(
  INITIAL_STATE,
  {
    '@filter/UPDATE_FILTER': (state, action) => {
      return {
        ...state,
        ...action.payload,
        isFirstLoad: false,
      };
    },
  }
);

export default filterReducer;
